<template>
  <div class="customer-service">
    <div class="customer-service__logo sf-secondary">
      <headphones/>
    </div>
    <h3 class="sf-mb-s">{{ $t("contacts-page.customer-service-title") }}</h3>

    <div v-for="{icon, data, type} in contacts" :key="data" class="item">
      <component :is="icon" class="item__icon"/>
      <app-phone-link v-if="type === types.phone" :phone-number="data" class="item__link"/>
      <app-email-link v-if="type === types.email" :email="data" class="item__link"/>
    </div>
  </div>
</template>

<script>
import Headphones from '~/static/img/icons/headphones.svg';
import Phone from '~/static/img/contacts/phone-in-talk.svg';
import Mail from '~/static/img/contacts/email.svg';
import AppPhoneLink from '~/components/links/phone-link.vue';
import AppEmailLink from '~/components/links/email-link.vue';

export default {
  name: 'ContactsCustomerService',
  components: { Headphones, AppEmailLink, AppPhoneLink },
  data() {
    return {
      types: {
        phone: 'phone',
        email: 'email',
      },
    };
  },
  computed: {
    contacts() {
      return [
        {
          icon: Phone,
          data: this.$t('contacts-page.tel-cc1'),
          type: this.types.phone,
        },
        {
          icon: Phone,
          data: this.$t('contacts-page.tel-cc2'),
          type: this.types.phone,
        },
        {
          icon: Phone,
          data: this.$t('contacts-page.tel-cc3'),
          type: this.types.phone,
        },
        {
          icon: Mail,
          data: this.$t('contacts-page.email-cc'),
          type: this.types.email,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-service {
  font-size: 20px;
  line-height: 30px;

  &__logo {
    @include square(85px);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: map-get($margins, small);
    border-radius: 50%;

    @include mobile {
      @include square(60px);
    }

    svg {
      @include square(70%);
    }
  }

  &:not(:last-child) {
    padding-right: map-get($paddings, small);
  }

  @include mobile {
    &:not(:first-child) {
      margin-top: map-get($margins, normal);
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  &__icon {
    @include square(24px);
    flex-shrink: 0;
    margin-right: 20px;
    fill: #333;
  }
}
</style>
